<div class="header-case">
    <span class="span-header">{{title}}</span>
    <div class="content-case">
        <span class="span-content" matTooltip="{{tooltip}}">
            {{content}}
        </span>
        <ng-content></ng-content>
    </div>
</div>